const config = {
    development: {
        API_BASE_URL: "http://localhost:5000",
        SSO_LOGIN_URL: "http://localhost:5000/auth/saml",
    },
    dev: {
        API_BASE_URL: "https://pcss-product-catalogue-dev.csgcloudapp.com",
        SSO_LOGIN_URL: "https://pcss-product-catalogue-dev.csgcloudapp.com/auth/saml",
    },
    qa: {
        API_BASE_URL: "https://pcss-product-catalogue-qa.csgcloudapp.com",
        SSO_LOGIN_URL: "https://pcss-product-catalogue-qa.csgcloudapp.com/auth/saml",
    },
    production: {
        API_BASE_URL: "https://pcss-product-catalogue.csgcloudapp.com",
        SSO_LOGIN_URL: "https://pcss-product-catalogue.csgcloudapp.com/auth/saml",
    },
  };
  
  const currentEnv = process.env.REACT_APP_ENV || "development";
  export default config[currentEnv];
  